import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { CRMService } from '../../services/crm.service';
import { CustomerInitiative } from '../../models/models';

@Component({
    selector: 'initiatives-dropdown',
    templateUrl: './initiatives-dropdown.component.html',
    standalone: false
})
export class InitiativesDropdown implements OnInit, OnChanges {

    @Input() selectedInitiative: CustomerInitiative = { title: '', description: '' } as CustomerInitiative;
    @Input() selectedInitiativeText: string = '';

    @Output() selectedInitiativeChanged = new EventEmitter<CustomerInitiative>();

    public initiatives: CustomerInitiative[] = []; 

    constructor(private crmService: CRMService) { }

    ngOnInit() {
        this.crmService.getCustomerInitiatives().subscribe(result => {
            this.initiatives = result;
        });
    }

    ngOnChanges(changes: SimpleChanges) {

    }
}